import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=b1d360a2&scoped=true"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"
import style0 from "./Frame.vue?vue&type=style&index=0&id=b1d360a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d360a2",
  null
  
)

export default component.exports